<template>
    <div class="fulltext-search-input-container relative">
        <input
            v-model="modelValueLocal"
            type="text"
            class="fulltext-search-input w-full pl-9 pr-9 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent"
            :class="inputClass"
            :placeholder="placeholder"
            :aria-label="accessibilityLabel"
            data-test="fulltext-search-input"
            @focus="handleSearch"
            @keyup.enter="handleSearch"
        >
        <button
            class="fulltext-search-icon-btn absolute left-3 top-1/2 transform -translate-y-1/2 p-0 border-0 bg-transparent"
            type="button"
            data-test="fulltext-search-button"
            tabindex="-1"
            @click="handleSearch"
        >
            <icon-search :class="iconClass" />
        </button>
        <button
            v-if="modelValueLocal"
            class="fulltext-search-clear-btn absolute right-2 top-1/2 transform -translate-y-1/2 p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-all duration-200 border-0 bg-transparent"
            type="button"
            data-test="fulltext-search-clear-button"
            @click="modelValueLocal = ''"
        >
            <icon-clear :class="iconClass" />
        </button>
    </div>
</template>

<script setup lang="ts">
    import { useVModel } from '@vueuse/core';
    import IconSearch from '~/components/icons/IconSearch.vue';
    import IconClear from '~/components/icons/IconClear.vue';

    type FulltextSearchInputProps = {
        modelValue: string;
        placeholder: string;
        accessibilityLabel: string;
        inputClass?: string;
        iconClass?: string;
    }

    type FulltextSearchInputEmits = {
        (e: 'update:modelValue', value: string): void;
        (e: 'search-performed'): void;
    }

    const props = withDefaults(defineProps<FulltextSearchInputProps>(), {
        inputClass: 'py-2',
        iconClass: 'w-4 h-4',
    });
    
    const emit = defineEmits<FulltextSearchInputEmits>();

    const modelValueLocal = useVModel(props, 'modelValue', emit);

    const handleSearch = () => {
        emit('search-performed');
    };
</script>

<style scoped lang="scss">
    .fulltext-search-input {
        transition: all 0.2s ease;
        
        &:focus {
            --tw-ring-color: var(--button-color, #3b82f6);
            border-color: var(--button-color, #3b82f6);
        }
    }

    .fulltext-search-icon-btn {
        color: #6b7280;
        
        &:hover {
            color: var(--button-color, #3b82f6);
        }
    }

    .fulltext-search-clear-btn {
        &:hover {
            color: var(--button-color, #3b82f6);
        }
    }
</style> 
